/*=========================================================================================
  File Name: moduleTypologyMutations.js
  Description: Typology Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_SESSION(state, session) {
		state.sessions.unshift(session);
	},
	SET_SESSIONS(state, sessions) {
		state.sessions = sessions;
	},
	UPDATE_SESSION(state, session) {
		const sessionIndex = state.sessions.findIndex((s) => s.access_token === session.access_token);
		Object.assign(state.sessions[sessionIndex], session);
	},
	REMOVE_SESSION(state, accessToken) {
		const ItemIndex = state.sessions.findIndex((s) => s.access_token === accessToken);
		state.sessions.splice(ItemIndex, 1);
	},
};
